<div class="compact-address-container">
  <div class="title">
    <div class="row">
      <!-- title -->
      <div class="col-lg-6">
        <h5>{{ "modeso_address_compact-address_address" | injectedText | async }}</h5>
      </div>
      
    </div>
  </div>
  <!-- address details -->
  <modeso-compact-address-details-view id="compactDeliveryAddress"
    [address]="deliveryAddress" [addressType]="'modeso_address_compact-address_delivery-address'"
    [isBillingAddress]="false">
  </modeso-compact-address-details-view>
  <modeso-compact-address-details-view id="compactBillingAddress" [address]="billingAddress"
    [addressType]="'modeso_address_compact-address_billing-address'" [isBillingAddress]="true">
  </modeso-compact-address-details-view>

</div>
